<p-dialog [(visible)]="modalOpen" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [modal]="true" [style]="{width: '60vw'}"
          appendTo="body">
  <ng-template pTemplate="header">
    <div class="flex align-items-center">
            <span class="flex align-items-center justify-content-center mr-3 border-circle text-shine"
                  style="width:32px;height:32px">
                <i class="fas fa-globe-americas text-lg"></i>
            </span>
      <span class="font-medium text-2xl text-900">New Organization</span>
    </div>
  </ng-template>

  <div class="surface-section py-2 px-2">
    <div class="grid">
      <div class="col-12">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label class="font-medium text-900" for="organizationCode">Organization Name</label>
            <input [(ngModel)]="organizationName" id="organizationCode" pInputText type="text" [problem-details]="problemDetails" problemDetailsKey="companyInformation.companyName">
          </div>
          <div class="field mb-4 col-12">
            <label class="font-medium text-900" for="organizationDescription">Organization Description</label>
            <textarea [(ngModel)]="organizationDescription" style="width: 100%;" id="organizationDescription" pInputTextarea rows="5" [problem-details]="problemDetails" problemDetailsKey="companyInformation.companyDescription">
                      type="text"></textarea>
          </div>
          <h2 *ngIf="invitations.length > 0" class="pl-2">Invite people to your team</h2>
          <div *ngFor="let invitation of invitations; let i = index" class="field mb-4 col-12">
            <h2 class="m-0 pl-2">Invite {{i + 1}}</h2>
            <div class="flex">
              <div class="field col-4">
                <label [for]="'email' + i" class="font-medium text-900">Email</label>
                <input [(ngModel)]="invitation.email" [id]="'email' + i" pInputText type="text" [problem-details]="problemDetails" [problemDetailsKey]="getUserProblemDetailsKey(i) + '.email'">
              </div>
              <div class="field col-3">
                <label [for]="'firstName' + i" class="font-medium text-900">First Name</label>
                <input [(ngModel)]="invitation.firstName" [id]="'firstName' + i" pInputText type="text" [problem-details]="problemDetails" [problemDetailsKey]="getUserProblemDetailsKey(i) + '.firstName'">
              </div>
              <div class="field col-3">
                <label [for]="'lastName' + i" class="font-medium text-900">Last Name</label>
                <input [(ngModel)]="invitation.lastName" [id]="'lastName' + i" pInputText type="text" [problem-details]="problemDetails" [problemDetailsKey]="getUserProblemDetailsKey(i) + '.lastName'">
              </div>
              <div class="col-2">
                <label class="font-medium text-900 text-white-alpha-90">Remove</label>
                <button (click)="removeInvitation(i)" class="p-button-outlined mr-2 mt-2" icon="pi pi-times"
                        pRipple>Remove</button>
              </div>
            </div>
          </div>
          <div class=""></div>
          <div class="mt-3 lg:mt-0 ml-2 mr-2">
            <button (click)="addInvitation()" class="p-button-outlined mr-2" icon="pi pi-plus"
                    pRipple>Add Invitation</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class=" border-top-1 surface-border pt-3">
      <button (click)="cancelNewOrganization()" class="p-button-text" icon="pi pi-times"
              pRipple>Cancel</button>
      <button (click)="checkNoInvitation()" [disabled]="!isFormValid" icon="pi pi-check"
              pRipple>Create</button>
    </div>
  </ng-template>

  <p-dialog [(visible)]="noInvitation" [breakpoints]="{'260px': '25vw', '340px': '50vw'}" [modal]="true" [style]="{width: '60vw'}" [closable]="false"
            appendTo="body" >
    <p>Are you sure don't want to invite anyone else to your organization? Don't worry, you can add members later if you need to.</p>
    <div class="flex justify-content-between pt-3">
      <button (click)="noInvitation = false" class="p-button-text" icon="pi pi-times"
              pRipple>Cancel</button>
      <button (click)="saveNewOrganization()" icon="pi pi-check"
              pRipple>Create</button>
    </div>
  </p-dialog>

  <p-dialog [(visible)]="isSubmitting" [modal]="true" [closable]="false">
    <p-progressSpinner></p-progressSpinner>
    <p>Please wait...</p>
  </p-dialog>


</p-dialog>
